import { render, staticRenderFns } from "./RetailerProduct.vue?vue&type=template&id=91bebd68&scoped=true&"
import script from "./RetailerProduct.vue?vue&type=script&lang=js&"
export * from "./RetailerProduct.vue?vue&type=script&lang=js&"
import style0 from "./RetailerProduct.vue?vue&type=style&index=0&id=91bebd68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bebd68",
  null
  
)

export default component.exports